import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ORGASMEAT_DEMO_ID, orgasmeatPickupToken, OrgasmeatReceiptLines, validateOrgasmeatDemoOrder } from './OrgasmeatOrderReceipt';
import './OrgasmeatOrderReceipt.css';

export default function OrgasmeatPickupPage() {
  const { id } = useParams();
  const location = useLocation();
  const token = orgasmeatPickupToken(location.hash);
  const scope = `${id}/${token}/${location.search}`;
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ scope: '', loading: true, order: null, error: '', retry: false });
  useEffect(() => {
    let active = true;
    let expiryTimer;
    const controller = new AbortController();
    const current = () => active && !controller.signal.aborted;
    setState({ scope, loading: true, order: null, error: '', retry: false });
    if (!ORGASMEAT_DEMO_ID.test(id || '') || !token || location.search) {
      setState({ scope, loading: false, order: null, error: 'Ce lien de retrait est incomplet ou invalide. Scanne le QR affiché à la fin de ta commande.', retry: false });
      return () => { active = false; controller.abort(); };
    }
    const timeout = setTimeout(() => {
      if (!current()) return;
      controller.abort();
      setState({ scope, loading: false, order: null, error: 'Le ticket met trop de temps à répondre. Réessaie dans un instant.', retry: true });
    }, 15000);
    const expire = () => {
      if (!active) return;
      setState({ scope, loading: false, order: null, error: 'Ce ticket de démonstration a expiré. Tu peux recommencer une nouvelle expérience.', retry: false });
    };
    async function load() {
      try {
        const response = await fetch(`/api/orgasmeat-demo/pickup/${id}`, {
          method: 'GET', headers: { Authorization: `Bearer ${token}` }, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal,
        });
        if (!current()) return;
        if ([400, 401, 403, 404, 410].includes(response.status)) {
          setState({ scope, loading: false, order: null, error: 'Ce ticket de démonstration est introuvable ou a expiré. Utilise le QR de ta dernière commande.', retry: false });
          return;
        }
        if (!response.ok) throw Error('unavailable');
        const order = validateOrgasmeatDemoOrder(await response.json());
        if (!current()) return;
        if (!order || order.id !== id) throw Error('invalid-order');
        const remaining = Date.parse(order.expiresAt) - Date.now();
        if (remaining <= 0) { expire(); return; }
        setState({ scope, loading: false, order, error: '', retry: false });
        expiryTimer = setTimeout(expire, Math.min(remaining, 2147483647));
      } catch {
        if (current()) setState({ scope, loading: false, order: null, error: 'Le ticket est momentanément indisponible. Vérifie ta connexion puis réessaie.', retry: true });
      } finally { clearTimeout(timeout); }
    }
    load();
    return () => { active = false; controller.abort(); clearTimeout(timeout); clearTimeout(expiryTimer); };
  }, [id, token, scope, location.search, attempt]);
  const current = state.scope === scope ? state : { loading: true, order: null, error: '', retry: false };
  const order = current.order;
  return <main className="om-pickup-page">
    <header className="om-receipt-brand"><img src="/orgasmeat/logo.svg" alt="ORGASMEAT" /><span>Démonstration</span></header>
    <section className="om-pickup-card" aria-label="Ton ticket de retrait">
      <h1>{order ? 'Ton ticket est ici.' : current.loading ? 'Ton ticket arrive…' : 'Ticket indisponible'}</h1>
      {current.loading && <p role="status">Recherche de ta commande de démonstration…</p>}
      {current.error && <p className="om-pickup-status" role="alert">{current.error}</p>}
      {order && <>
        <span className="om-receipt-label">Numéro de commande</span><strong className="om-receipt-number">#{String(order.ticketNumber).padStart(4, '0')}</strong>
        <p>Dans le restaurant, ce numéro sert à retrouver ta commande au comptoir.</p>
        <p><strong>Ce ticket est une démonstration.</strong> Aucun paiement ni préparation réelle.</p>
        <OrgasmeatReceiptLines order={order} />
        <p className="om-pickup-expiry">Disponible jusqu’au {new Date(order.expiresAt).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}.</p>
      </>}
      {current.retry && <button className="om-receipt-button" type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button>}
      <a className="om-pickup-return" href="/orgasmeat/" referrerPolicy="no-referrer">Découvrir l’expérience ORGASMEAT</a>
    </section>
  </main>;
}
